import { Components, Theme } from '@mui/material';

/**
 * Pickers render in a portal under `document.body`, outside the app root where `color-scheme` may be set.
 * Without this, native scrollbars in the dropdown (e.g. multi-section digital clock columns) stay light in dark mode.
 */
export const MuiPickersPopper: Components<Theme>['MuiPickersPopper'] = {
  styleOverrides: { paper: ({ theme }) => ({ colorScheme: theme.palette.mode }) },
};
